(function () {
  function isStrapLegendText(t) {
    return /strap colour|strap color/i.test(t || "");
  }

  function apply() {
    const fieldsets = document.querySelectorAll("fieldset.variant-option");
    fieldsets.forEach((fs) => {
      const legend = fs.querySelector("legend");
      if (!legend) return;
      if (!isStrapLegendText(legend.textContent)) return;

      const inputs = Array.from(fs.querySelectorAll("input[type='radio'][data-strap-group]"));
      if (!inputs.length) return;

      // Remove any previous headings we injected
      fs.querySelectorAll("[data-strap-heading]").forEach((n) => n.remove());

      // We need the LI nodes that contain each input
      const items = inputs
        .map((inp) => {
          const li = inp.closest("li.variant-option__swatch");
          return li ? { inp, li, g: inp.getAttribute("data-strap-group") } : null;
        })
        .filter(Boolean);

      if (!items.length) return;

      const limited = items.filter((x) => x.g === "limited").map((x) => x.li);
      const core = items.filter((x) => x.g !== "limited").map((x) => x.li);

      const container = items[0].li.parentElement;
      if (!container) return;

      function heading(text) {
        const li = document.createElement("li");
        li.setAttribute("data-strap-heading", "true");
        li.className = "variant-option__swatch";
        li.innerHTML =
          '<div class="variant-option__button-label variant-option__button-label--has-swatch swatch-rounded" ' +
          'style="width:100%;justify-content:flex-start;font-weight:700;padding:8px 10px;background:rgba(0,0,0,0.04)">' +
          text +
          "</div>";
        return li;
      }

      // Rebuild order: limited section, then core section
      const frag = document.createDocumentFragment();

      if (limited.length) {
        frag.appendChild(heading("Limited Edition Strap Colours"));
        limited.forEach((li) => frag.appendChild(li));
      }

      if (core.length) {
        frag.appendChild(heading("Core Strap Colours"));
        core.forEach((li) => frag.appendChild(li));
      }

      container.appendChild(frag);
    });
  }

  function boot() {
    apply();
    // Keep applying after theme re-renders
    const obs = new MutationObserver(apply);
    obs.observe(document.documentElement, { subtree: true, childList: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
